import { Button, Col, Divider, Image, Row, Space } from "antd";
import SocialMediaButtons, { Handle } from "@components/social-media-buttons/SocialMediaButtons";
import { Image as IImage, Link } from "@customTypes/index";
import { EnvelopIcon, LinkIcon } from "@components/icons/Icons";
interface AvatarStackCtaProps {
  className: string;
  title: string;
  email: string;
  website: string;
  roles: string[];
  subTitle?: string;
  link: Link;
  socialHandles: Handle[];
  image: IImage;
}

const defaultProps: AvatarStackCtaProps = {
  className: "",
  title: "No title found",
  subTitle: "No title found",
  socialHandles: [],
  website: '',
  roles: ['Writer'],
  email: '',
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
  image: {
    src: "https://covrprice.com/wp-content/uploads/2020/02/STL145248.jpg",
    alt: "no image",
    width: 55,
    height: 55,
  },
};

const AvatarStackCta = ({
  className,
  title,
  email,
  website,
  subTitle,
  link,
  image,
  roles,
  socialHandles
}: AvatarStackCtaProps) => {
  return (
    <div className={`covr-avatar-cta ${className}`}>
      <Row justify="space-between" align="middle">
        <Col flex={`80px`}>
          <Image
            style={{
              borderRadius: "50%",
            }}
            preview={false}
            className="img responsive-img"
            src={image.src}
            width={image.width}
            height={image.height}
          />
        </Col>
        <Col flex={`auto`}>
          <Row justify="space-between">
            <Col xs={24} sm={12} lg={12} xl={12} className={`details`}>
              <h4 className="title">{title}</h4>
              <small className="subtitle">
                {roles
                  && roles.map((role, index) => {
                    const comma = (index < roles.length - 1) ? ', ' : '';
                    return <span>{`${role}${comma}`}</span>
                  })
                }
              </small>
            </Col>
            <Col xs={24} sm={12} lg={12} xl={12} className={`actions`}>
              <Space align={`center`} size={0}>
                {email && (
                  <Button className="pad-x-0" size="small" href={link.url} type="link" title="email">
                    <EnvelopIcon />
                  </Button>
                )}
                {website && (
                  <Button className="pad-x-0" size="small" href={website} type="link" title="website">
                    <LinkIcon />
                  </Button>
                )}
                {(email || website) && (<Divider type="vertical" />)}
                <SocialMediaButtons />
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

AvatarStackCta.defaultProps = defaultProps;

export default AvatarStackCta;
